import { ERROR_CODES } from "@scalephant/domain";
import { z } from "zod";

/**
 * The one error envelope every API response uses (IMPLEMENTATION_PLAN.md §2.4).
 * `message` is only meaningful for client-safe errors; otherwise it is generic and
 * `correlationId` is what to search the logs for.
 */
export const ErrorResponseSchema = z
  .object({
    error: z.object({
      code: z.enum(ERROR_CODES),
      message: z.string(),
      correlationId: z.string(),
      details: z.record(z.string(), z.unknown()).optional(),
    }),
  })
  .meta({ id: "ErrorResponse" });

export type ErrorResponse = z.infer<typeof ErrorResponseSchema>;
